import React from 'react';
import { useTranslation } from 'react-i18next';
import EllipsisIcon from '../../../Icons/Ellipsis';
import MoreMenuContent from '../../_partials/MoreMenu/MoreMenuContent';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
export var MoreButton = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    return (React.createElement(ActionBarButton, { allowMobilePopover: true, renderPopover: function (_a) {
            var closeTooltip = _a.closeTooltip;
            return (React.createElement(MoreMenuContent, { deviation: deviation, closeTooltip: closeTooltip }));
        }, tooltip: t('actionbar.more.tooltip') },
        React.createElement(ActionBarIcon, { icon: EllipsisIcon })));
};
MoreButton.displayName = 'MoreButton';
export default MoreButton;
//# sourceMappingURL=MoreButton.js.map